// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e9fc27af","239":"69b62133","453":"035da823","455":"c943c8c6"}[chunkId] + ".chunk.js";
};